import { Minus, Plus } from "lucide-react";
import styles from "./QuantityControl.module.css";

interface QuantityControlProps {
    amount: number;
    onDecrease: () => void;
    onIncrease: () => void;
    disableIncrease?: boolean;
    disableDecrease?: boolean;
    className?: string;
}

const QuantityControl = ({
    amount,
    onDecrease,
    onIncrease,
    disableIncrease = false,
    disableDecrease = false,
    className,
}: QuantityControlProps) => {
    return (
        <div className={`${styles.QuantityControl} ${className ?? ""}`}>
            <button
                className={styles.DecreaseButton}
                onClick={onDecrease}
                disabled={disableDecrease}
            >
                <Minus />
            </button>
            <div className={styles.AmountText}>
                <p>{amount}</p>
            </div>
            <button
                className={styles.IncreaseButton}
                onClick={onIncrease}
                disabled={disableIncrease}
            >
                <Plus />
            </button>
        </div>
    );
};

export default QuantityControl;
